import axiosInstance from "../axiosInstance/axiosInstance";
import { ProjectResponse } from "../contracts/ProjectResponse";
import { Project } from "./Project";
import { ProjectResponseMapper } from "./ProjectResponseMapper";

export const fetchAllAccessibleProjects = async (): Promise<Project[]> => {
  try {
    const response = await axiosInstance.get(`/api/projects`);

    const data: ProjectResponse[] = response.data;
    const projectResponseMapper = new ProjectResponseMapper();
    const mappedResponse: Project[] = data.map((project) =>
      projectResponseMapper.mapProjectResponseToProject(project)
    );
    return mappedResponse;
  } catch (error) {
    throw error;
  }
};
